import './style.scss'
import React from 'react'
import { Avatar, List, Space, Tag, Tooltip, Typography } from 'antd'
import { SelectOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import BoringAvatar from 'boring-avatars'

const TRIPSHA_COLORS = ['#20a39e', '#ec6350', '#f5a590', '#7fd3d0', '#d9d9d9']

const boringAvatarSeed = (user) => {
  if (user?.firstName?.trim() || user?.lastName?.trim())
    return `${user?.firstName || ''} ${user?.lastName || ''}`.trim()
  return user?.username || user?.email || user?._id || 'user'
}

export const ProfilePicture = ({ user, size, className = '', style = {} }) => {
  const px = size || 60
  if (user?.avatarUrl)
    return (
      <Avatar
        key={user._id}
        size={px}
        src={user.avatarUrl}
        style={{ ...style, minWidth: `${px}px` }}
      />
    )

  return (
    <span
      key={user?._id}
      className={`ant-avatar ${className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: `${px}px`,
        height: `${px}px`,
        minWidth: `${px}px`,
        flexShrink: 0,
        border: 'none',
        background: 'none',
        ...style,
      }}
    >
      <BoringAvatar size={px} name={boringAvatarSeed(user)} variant="beam" colors={TRIPSHA_COLORS} />
    </span>
  )
}
const title = (guests) => {
  return (
    <List
      size="small"
      header="Guests"
      itemLayout="horizontal"
      className='guest-popup-information'
      dataSource={guests}
      renderItem={(item, idx) => {
        return (
          <List.Item>
            <List.Item.Meta
              title={<Typography.Title level={5}>{item.name}</Typography.Title>}
              avatar={
                <ProfilePicture
                  user={{ ...item, firstName: item.name, _id: idx }}
                  size={50}
                />
              }
              description={
                <Space direction="vertical" size={0}>
                  <Typography.Text>{item.email}</Typography.Text>
                  <Typography.Text type="secondary">
                    {item.relationship}
                  </Typography.Text>
                </Space>
              }
            />
          </List.Item>
        )
      }}
    />
  )
}
export const UserInfoLine = ({
  user,
  showEmail = false,
  showGuest = true,
  showLink = true,
  style = {},
}) => {
  const name = `${user?.firstName?.trim() || ''} ${user?.lastName?.trim() || ''
    }`.trim()
  return (
    <div className="profile-line-container" style={style}>
      <div className="profile-line">
        <ProfilePicture user={user} size={30} />
        {showEmail ? (
          <div className="name">
            <div>{name ? name : user?.email}</div>
            <div className="sub-text">{user?.email}</div>
          </div>
        ) : (
          <div className="name">{name}</div>
        )}
        {showGuest && user?.attendees > 1 && (
          <Tooltip color="#ffffff" title={title(user.guests)}>
            <Tag style={{ marginRight: '20px' }}>+{user?.attendees > 2 ? 'Group' : '+' + user?.attendees - 1}</Tag>
          </Tooltip>
        )}
      </div>
      {showLink && user?.username && (
        <Link to={'/profile/' + user?.username} target="_blank">
          <SelectOutlined style={{ cursor: 'pointer' }} />
        </Link>
      )}
    </div>
  )
}

export const OrganizationProfilePicture = ({
  organization,
  size = 60,
  className = '',
  style = {},
}) => {
  if (organization?.avatarUrl)
    return (
      <Avatar
        key={organization._id}
        size={size}
        src={organization.avatarUrl}
        style={{ ...style, minWidth: `${size}px` }}
      />
    )

  let char = ''
  if (organization?.name?.trim()?.length > 0) {
    char = organization?.name?.trim()[0]
  }
  return (
    <Avatar
      key={organization?._id}
      size={size}
      className={className}
      style={{
        ...style,
        backgroundColor: '#EC6350',
        minWidth: `${size}px`,
      }}
    >
      {char ? char.toUpperCase() : ''}
    </Avatar>
  )
}
